import { defineStore } from "pinia";

export const useSearchPage = defineStore('searchPage', {
    state: () => {
      return {
        sortValue: 0, // 排序方式 0打印量优先 1好评率优先 2新商品优先
      }
    },
    getters:{},
    actions: {
    }
  })